<template>
  <div class="root">
    <b-container class="" fluid>
      <b-row>
        <b-col>
          <div class="flex-div">
            <div class="left-flex-child">
              <div class="l-content">
                <p class="b-header">Hey {{ details.fname }}</p>
                <p class="s-header">
                  Hope you're grinding your preparations for exam?
                </p>
              </div>
            </div>
            <div class="right-flex-child text-right">
              <b-overlay
                :show="false"
                opacity="0.7"
                spinner-variant="dark"
                spinner-small
                rounded
                class="mt-5 py-3"
              >
                <template v-slot:overlay>
                  <b-link :to="{ name: 'upgrade' }">
                    <div class="text-center mt-4 w-100">
                      <p>
                        <b-icon-lock-fill
                          variant="warning"
                          font-scale="2"
                        ></b-icon-lock-fill>
                        Upgrade to Unlock
                      </p>
                    </div>
                  </b-link>
                </template>
                <b-button
                  class="v-button ml-3"
                  :to="{ name: 'select' }"
                  variant="success"
                  >Take a Test</b-button
                >
              </b-overlay>
            </div>
          </div>
        </b-col>
      </b-row>

      <div class="mt-5">
        <b-alert
          dismissible
          :show="discountdetails.discount_season"
          variant="info"
        >
          <p class="discount-text">
            Discount alert! {{ discountdetails.discount_title }}!
          </p>
          <p class="discount-text">
            <strong class="discount-value"
              >{{ discountdetails.discount_percentage }}%</strong
            >
            off on all upgrades
          </p>
          <b-button class=" p-lg-2" :to="{ name: 'upgrade' }" variant="info"
            >Upgrade NOW</b-button
          >
        </b-alert>
      </div>

      <b-row class="mt-4">
        <b-col lg="6" class="mt-2">
          <div class="dash-card latestresults p-3">
            <div class="m-3">
              <b-row>
                <b-col cols="7">
                  <p class="card-legend">Latest Scores</p>
                </b-col>
                <b-col cols="5" class="text-right">
                  <b-button
                    :to="{ name: 'moreresults' }"
                    class="ll"
                    variant="outline-success"
                    >See More</b-button
                  >
                </b-col>
              </b-row>
            </div>
            <b-skeleton-wrapper
              class="text-center"
              :loading="miniresultfetched == false && resultsarr.length <= 0"
            >
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </template>
              <div v-if="resultsarr.length == 0 && miniresultfetched == false">
                You have not taken any tests Yet!.
                <router-link :to="{ name: 'select' }">Take One!</router-link>
              </div>
              <div v-else>
                <mini-results
                  v-for="(result, index) in resultsarr"
                  :result="result"
                  :key="index"
                  class="dash-card-item"
                ></mini-results>
              </div>
            </b-skeleton-wrapper>
          </div>
        </b-col>

        <b-col lg="6" class="mt-2">
          <div class="dash-card minischedule p-3">
            <div class="m-3">
              <b-row>
                <b-col cols="7">
                  <p class="card-legend">Upcoming Test Schedules</p>
                </b-col>
                <b-col cols="5" class="text-right">
                  <b-button
                    :to="{ name: 'scheduler' }"
                    class="ll"
                    variant="outline-success"
                    >See More</b-button
                  >
                </b-col>
              </b-row>
            </div>
            <b-skeleton-wrapper
              class="text-center"
              :loading="!upschedulesfetched"
            >
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </template>
              <div v-if="schedulesup.length == 0">
                You don't have any upcoming schedule.
                <router-link :to="{ name: 'scheduler' }"
                  >Create One!</router-link
                >
              </div>
              <up-schedules
                v-for="(schedule, index) in schedulesup"
                :key="index"
                :schedule="schedule"
                type="up"
                from="dashhome"
                class="dash-card-item p-2"
              ></up-schedules>
            </b-skeleton-wrapper>
          </div>
        </b-col>

        <b-col xs="12">
          <div class="dash-card p-3 mt-4">
            <div class="m-3">
              <b-row>
                <b-col cols="7">
                  <p class="card-legend">Performance Curve</p>
                </b-col>
                <b-col cols="5" class="text-right">
                  <b-button
                    :to="{ name: 'performancecurve' }"
                    class="ll"
                    variant="outline-success"
                    >See More</b-button
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <mini-graph :gdata="data"></mini-graph>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import miniResults from "@/components/miniResults";
// import miniSchedule from "@/components/miniSchedule";
import upSchedules from "@/components/upSchedules";
import miniGraph from "@/components/miniGraph";
import { mapState, mapActions } from "vuex";
// import store from "@/store";

export default {
  components: {
    miniResults,
    // miniSchedule,
    upSchedules,
    miniGraph
  },
  data() {
    return {
      dt: new Date(),
      curD: new Date(),
      mainProps: { width: 75, height: 75, class: "m1" },
      data: {}
    };
  },
  created() {
    this.retrieveInstitutions();

    if (this.details.category == "Organization") {
      this.$router.push({
        name: "orgdashboard"
      });
    }
  },
  // mounted(){
  //   if (store.state.loginmaster.loggedIn) {
  //     store.dispatch("dashboard/fetchNotifications");
  //     store.dispatch("dashboard/getminiresults");
  //     store.dispatch("dashboard/upSchedules");
  //     store.dispatch("exam/retrieveCategories");
  //     store.dispatch("exam/retrieveInstitutions");
  //     store.dispatch("exam/retrieveTopics");
  //     store.dispatch("dashboard/retrieveLeaderboardI");
  //     store.dispatch("dashboard/retrieveLeaderboard");
  //     store.dispatch("exam/retrieveInstitutions");
  //     store.dispatch("dashboard/pastSchedules");
  //     store.dispatch("dashboard/overallGraph");
  //     store.dispatch("dashboard/subjectGraph");
  //     store.dispatch("dashboard/getmaxiresults");
  //     store.dispatch("dashboard/retrieveTestspaces");
  //     store.dispatch("dashboard/fetchUsermetrics");
  //     store.dispatch("dashboard/fetchReferrals");
  //     store.dispatch("loginmaster/trialsLeft");
  //   }
  // },
  watch: {
    gdata() {
      this.data = this.gdata;
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   // NProgress.start()

  //   next();
  //   //NProgress.done()
  // },
  methods: {
    ...mapActions("exam", ["retrieveInstitutions"])
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      resultsarr: state => state.dashboard.lresults,
      donelr: state => state.dashboard.donelresults,
      schedulesup: state => state.dashboard.upschedules,
      plan: state => state.loginmaster.details.plan,
      upschedulesfetched: state => state.dashboard.upschedulesfetched,
      miniresultfetched: state => state.dashboard.miniresultfetched,
      allinsti: state => state.exam.allinstitutions,
      gdata: state => state.dashboard.overallgraph,
      trial: state => state.loginmaster.trial,
      discountdetails: state => state.loginmaster.details.discount_details
    }),

    lresultsre() {
      if (this.donelr == false && this.resultsarr.length <= 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.dash-card {
  min-height: 70vh;
  background-color: white;
  border-radius: 20px 20px;
}

.ll {
  text-decoration: none;
  color: black;
  font-size: 0.8rem;
}
.card-legend {
  font-weight: bold;
  font-size: 1.2rem;
}

.mll {
  color: #00377b;
}

.llrs {
  font-size: 0.9rem;
  line-height: 1rem;
  margin-bottom: -10px;
}

.dash-card-item {
  border-radius: 10px 10px;
}
.dash-card-item:hover {
  background-color: #f0f0f0;
}
.v-button {
  border-radius: 10px 10px;
  width: 12rem;
  height: 5rem;
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
  margin-top: -7px;
  padding-top: 20px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}
.l-content {
  position: relative;
  top: 20%;
}
.flex-div {
  display: flex;
  flex-flow: row wrap;
}
.left-flex-child {
  width: 60%;
}
.right-flex-child {
  width: 40%;
  height: 4rem;
}
.b-header {
  font-size: 32px;
  color: #00984a;
}
.s-header {
  font-size: 20px;
}
.discount-text {
  font-size: 20px;
  font-weigth: bold;
}
.discount-value {
  font-size: 25px;
}
@media (min-width: 768px) {
}

@media (max-width: 999px) {
  .v-button {
    width: 8.5rem;
    height: 4.5rem;
    font-size: 1rem;
    padding-top: 24px;
  }
  .s-header {
    font-size: 16px;
  }
}
</style>
